/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, Button, Chip, IconButton, Select, styled, TextField, Typography } from "@mui/material";
import { fonts } from "../../themes/dashboard";

export const ProfileDialogPaperProps = {
  sx: {
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
    overflow: "hidden",
    padding: 0,
  },
};

export const scrollableContent = {
  padding: "0px",
  overflowY: "auto",
};

export const TitleContainer = styled(Box)({
  alignItems: "center",
  borderBottom: "1px solid #e4e4e7",
  display: "flex",
  justifyContent: "space-between",
  padding: "16px 24px",
});

export const TitleText = styled(Typography)({
  color: "#18181b",
  fontFamily: fonts?.fontFamily,
  fontSize: "18px",
  fontWeight: "600",
  letterSpacing: "0px",
});

export const CloseIconButton = styled(IconButton)({
  color: "#71717a",
  padding: "4px",
  "&:hover": {
    color: "#18181b",
  },
});

export const SectionContainer = styled(Box)({
  borderBottom: "1px solid #e4e4e7",
  padding: "20px 24px",
  "&:last-of-type": {
    borderBottom: "none",
  },
});

export const SectionTitle = styled(Typography)({
  color: "#18181b",
  fontFamily: fonts?.fontFamily,
  fontSize: "15px",
  fontWeight: "600",
  letterSpacing: "0px",
});

export const SectionHelperText = styled(Typography)({
  color: "#71717a",
  fontFamily: fonts?.fontFamily,
  fontSize: "12px",
  fontWeight: "400",
  letterSpacing: "0px",
  marginBottom: "12px",
});

export const FieldContainer = styled(Box)({
  marginBottom: "14px",
});

export const FieldLabel = styled("label")({
  color: "#3f3f46",
  display: "block",
  fontFamily: fonts?.fontFamily,
  fontSize: "13px",
  fontWeight: "600",
  marginBottom: "6px",
});

export const RequiredMark = styled("span")({
  color: "#d32f2f",
  marginLeft: "3px",
});

export const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "14px",
    "& fieldset": {
      borderColor: "#e4e4e7",
    },
    "&:hover fieldset": {
      borderColor: "#395bbd",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#395bbd",
    },
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#a1a1aa",
    opacity: 1,
  },
});

export const StyledSelect = styled(Select)({
  borderRadius: "8px",
  fontSize: "14px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#e4e4e7",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#395bbd",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#395bbd",
  },
});

export const selectMenuProps = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  PaperProps: { sx: { maxHeight: "40vh" } },
  autoFocus: false,
  MenuListProps: { sx: { pt: 0 } },
};

export const SelectPlaceholder = styled("span")({
  color: "#a1a1aa",
  fontSize: "14px",
});

export const RoleChip = styled(Chip)({
  backgroundColor: "#e9f0f9",
  fontSize: "12px",
  height: "22px",
});

export const ErrorText = styled(Typography)({
  color: "#d32f2f",
  fontFamily: fonts?.fontFamily,
  fontSize: "12px",
  fontWeight: "400",
  letterSpacing: "0px",
  marginTop: "4px",
});

export const StatusRow = styled(Box)({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  gap: "10px",
});

export const StatusHelperText = styled(Typography)({
  color: "#71717a",
  fontFamily: fonts?.fontFamily,
  fontSize: "12px",
  fontWeight: "400",
  letterSpacing: "0px",
});

export const FixedActionContainer = styled(Box)({
  alignItems: "center",
  backgroundColor: "#ffffff",
  borderTop: "1px solid #e4e4e7",
  display: "flex",
  gap: "10px",
  justifyContent: "flex-end",
  padding: "14px 24px",
});

export const SaveButton = styled(Button)({
  "&.Mui-disabled": {
    backgroundColor: "#e0e0e0",
  },
  "&:hover": {
    backgroundColor: "#395bbd",
    boxShadow: "none",
  },
  backgroundColor: "#395bbd",
  boxShadow: "none",
  borderRadius: "8px",
  fontSize: "13px",
  fontWeight: "600",
  height: "35px",
  minWidth: "120px",
  padding: "0px 15px",
  textTransform: "none",
});
